<template>
    <div :class="isMobile == 0 ? '' : 'Project_mobile'" class="Project">
        <div :class="isMobile == 0 ? '' : 'Project_box_mobile'" class="Project_box">
            <div class="Project_top" v-if="lang.fyType == 2">{{ BigType }}/{{
                lanType[0].language == 'en' ? lanType[0].content : lanType[1].content }}/{{
                    twoItem.translations.name.content }}</div>
            <div class="Project_top" v-else>{{ BigType }} / {{
                lanType[0].language == 'zh' ? lanType[0].content : lanType[1].content }}/{{ twoItem.name }} </div>
            <div class="Project_title" v-if="GoodDetail.translations.name">{{ GoodDetail.translations.name.content }}</div>
            <img :class="isMobile == 0 ? '' : 'Project_img_mobile'" class="Project_img"
                :src="'https://app.choisiyachts.com' + imgList1[imgIndex1]" />
            <div :class="isMobile == 0 ? '' : 'Project_name_mobile'" class="Project_name">
                <div class="Project_name_text"
                    v-if="GoodDetail.translations.name && GoodDetail.translations.features">{{
                        GoodDetail.translations.name.content }},{{
                        GoodDetail.translations.features.content }}</div>
                <div class="Project_name_right">
                    <img class="Project_next_img pni_sp" src="../assets/nextimg.png" @click="imgChange(1)" />
                    <img class="Project_next_img" src="../assets/nexttimg.png" @click="imgChange(2)" />
                </div>
            </div>
            <div v-if="GoodDetail.translations.description" :class="isMobile == 0 ? '' : 'Project_content_mobile'" class="Project_content"
                v-html="GoodDetail.translations.description.content"></div>

            <img :class="isMobile == 0 ? '' : 'Project_img_mobile'" class="Project_img"
                :src="'https://app.choisiyachts.com' + imgList2[imgIndex2]" />
            <div class="Project_name">
                <div class="Project_name_text"
                    v-if="GoodDetail.translations.name && GoodDetail.translations.specification">{{
                        GoodDetail.translations.name.content }},{{
                        GoodDetail.translations.specification.content }}</div>
                <div class="Project_name_right">
                    <img class="Project_next_img pni_sp" src="../assets/nextimg.png" @click="imgChange(3)" />
                    <img class="Project_next_img" src="../assets/nexttimg.png" @click="imgChange(4)" />
                </div>
            </div>
            <template v-if="projectData1Fen && projectData1Fen.length > 0">
                <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-if="lang.fyType == 2">Combination
                    method
                </div>
                <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-else>组合方式</div>
                <div class="pro_boxs">
                    <!-- @click="gotoDetai(item.id)" -->
                    <div class="pro_box" v-for="(item, index) in projectData1Fen[projectData1FenIndex]" :key="index">
                        <img class="prob_img" :src="'https://app.choisiyachts.com' + item.src" />
                        <div>{{ item.alt }}</div>
                    </div>
                </div>
                <div class="Project_name_right pnr_sp">
                    <img class="Project_next_img pni_sp" src="../assets/nextimg.png" @click="changeImg(1)" />
                    <img class="Project_next_img" src="../assets/nexttimg.png" @click="changeImg(2)" />
                </div>
            </template>

            <!-- 关联产品 related_products -->
            <template v-if="relatedProducts && relatedProducts.length > 0">
                <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-if="lang.fyType == 2">Related
                    products</div>
                <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-else>关联产品</div>
                <div class="pro_boxs related_boxs">
                    <div class="pro_box related_box" @click="gotoDetai(item.id)"
                        v-for="(item, index) in relatedProducts" :key="'related-' + item.id + '-' + index">
                        <img v-if="getRelatedImg(item)" class="prob_img"
                            :src="'https://app.choisiyachts.com' + getRelatedImg(item)" />
                        <div class="related_placeholder" v-else></div>
                        <div class="related_name">{{ item.product_name || (item.translations && item.translations.name &&
                            item.translations.name.content) }}</div>
                        <div class="related_cat" v-if="item.category_name">{{ item.category_name }}</div>
                    </div>
                </div>
            </template>

            <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-if="lang.fyType == 2">Other
                products in
                this series
                <img class="pos_next_img" src="../assets/nexttimg.png" @click="goBack()" />
            </div>
            <div :class="isMobile == 0 ? '' : 'pro_title_mobile'" class="pro_title" v-else>其它系列产品

                <img class="pos_next_img" src="../assets/nexttimg.png" @click="goBack()" />
            </div>
            <div class="pro_boxs pbb_sp">
                <!-- <div class="pro_box" v-for="(item, index) in imgList4" :key="index">
                    <img class="prob_img" :src="'https://app.choisiyachts.com' + item" />
                </div> -->
                <div class="pro_box" @click="gotoDetai(item.id)" v-for="(item, index) in projectData" :key="index">
                    <img class="prob_img" :src="'https://app.choisiyachts.com' + getImg(item)" />
                </div>
            </div>
            <div class="spsp" @click="goBack()">
                <div v-if="lang.fyType == 2" class="pro_button">Return to Category <img src="../assets/bluenext.png"
                        class="img_spspsp" /></div>
                <div v-else class="pro_button">返回类别 <img class="img_spspsp" src="../assets/bluenext.png" />
                </div>
            </div>
        </div>
        <bottom-text></bottom-text>
    </div>
</template>

<script>
import { GoodDetail, proList } from '../../request/api.js'
import router from '@/router';
import bottomText from './bottomText.vue';
export default {
    components: {
        bottomText
    },
    name: 'Projects',
    data() {
        return {
            lang: {},
            GoodDetail: null,
            projectData: [],
            projectData1: [],
            projectData1Fen: [],
            projectData1FenIndex: 0,
            imgList1: [],
            imgList2: [],
            imgList3: [],
            imgList4: [],
            imgIndex1: 1,
            imgIndex2: 0,
            imgIndex3: 0,
            imgIndex4: 0,
            proListId: '',
            lanType: JSON.parse(localStorage.getItem('lanType')),
            bottomGoodId: null,
            isMobile: 0,
            twoItem: null,
            relatedProducts: []
        }
    },
    watch: {
        lang: {
            handler(newLang, oldLang) {
                console.log('Lang 变化了：', newLang);
            },
            deep: true,
            immediate: true
        }
    },
    computed: {
        BigType() {
            return this.$route.params.type || '未知大类';
        },
        SmallType() {
            return this.$route.params.smalltype || '未知小类';
        },
        GoodId() {
            return this.$route.params.id || '未知产品'
        }
    },
    mounted() {
        this.twoItem = JSON.parse(localStorage.getItem('twoItem'))
        this.isMobile = localStorage.getItem('isMobile')
        this.proListId = localStorage.getItem('proListId')
        this.lang = JSON.parse(localStorage.getItem('Lang'))
        if (this.lang.fyType == 2) {
            this.getGood('en', true);
            this.getProList(this.proListId, 'en');
        } else {
            this.getGood('zh', true);
            this.getProList(this.proListId, 'zh');
        }
        window.addEventListener('langChange', () => {
            this.syncLangFromStorage();
        });
    },
    methods: {
        changeImg(type) {
            if (type == 1) {
                if (this.projectData1FenIndex != 0) {
                    this.projectData1FenIndex = this.projectData1FenIndex - 1;
                }
            }
            if (type == 2) {
                if (this.projectData1FenIndex != this.projectData1Fen.length - 1) {
                    this.projectData1FenIndex = this.projectData1FenIndex + 1;
                }
            }

        },
        gotoDetai(id) {
            this.bottomGoodId = id; // 记录新产品ID
            // 加载新数据（滚动逻辑在getGood成功回调中）
            if (this.lang.fyType == 2) {
                this.getGood('en', true);
            } else {
                this.getGood('zh', true);
            }
        },
        go() {
            // this.$router.go('/category')
        },
        getImg(item) {
            return item.images[0].image_url.split(',')[0] || ''; // 加可选链避免无图报错
        },
        getRelatedImg(item) {
            if (!item) return '';
            if (item.images && item.images.length) {
                const url = item.images[0].image_url || '';
                return url.split(',')[0] || '';
            }
            if (item.image_url) {
                return String(item.image_url).split(',')[0];
            }
            if (item.cover_image) {
                return String(item.cover_image).split(',')[0];
            }
            return '';
        },
        // 关联产品列表通常无图，补拉详情拿首图
        loadRelatedProductImages(list, language) {
            if (!list || !list.length) {
                this.relatedProducts = [];
                return;
            }
            this.relatedProducts = list.map((item) => ({ ...item }));
            const tasks = list.map((item) =>
                GoodDetail({ id: item.id, language }).then((res) => {
                    const detail = res.data || {};
                    return {
                        ...item,
                        images: detail.images || [],
                        translations: detail.translations || item.translations,
                        product_name: item.product_name || detail.product_name,
                        category_name: item.category_name || detail.category_name
                    };
                }).catch(() => ({ ...item }))
            );
            Promise.all(tasks).then((enriched) => {
                this.relatedProducts = enriched;
            });
        },
        getProList(category_id, language) {
            let data = {
                page: 1,
                limit: 9999,
                type: 2,
                is_recommend: 1,
                language
            }
            proList(data).then((res) => {
                // this.projectData = res.data.data;
                for (let i = 0; i < res.data.data.length; i++) {
                    if(res.data.data[i].id != this.GoodId ){
                        this.projectData.push(res.data.data[i])
                    }
                }
            })
            // let data1 = {
            //     page: 1,
            //     limit: 9999,
            //     type: 2,
            //     is_hot: 1,
            //     language
            // }
            // proList(data1).then((res) => {
            //     this.projectData1 = res.data.data;

            //     const result = [];
            //     for (let i = 0; i <  this.projectData1.length; i += 3) {
            //         // 截取从i开始，长度为size的子数组（不足3个则取剩余）
            //         const chunk = this.projectData1.slice(i, i + 3);
            //         result.push(chunk);
            //     }
            //     this.projectData1Fen = result;
            // })
        },
        syncLangFromStorage() {
            this.lang = JSON.parse(localStorage.getItem('Lang'))
            if (this.lang.fyType == 2) {
                this.getGood('en', false);
            } else {
                this.getGood('zh', false);
            }
        },
        imgChange(type) {
            if (type == 1) {
                this.imgIndex1 = this.imgIndex1 == 0 ? this.imgList1.length - 1 : this.imgIndex1 - 1;
                if (this.imgIndex1 == 0) {
                    this.imgIndex1 = this.imgList1.length - 1;
                }
            } else if (type == 2) {
                this.imgIndex1 = this.imgIndex1 == this.imgList1.length - 1 ? 0 : this.imgIndex1 + 1;
                if (this.imgIndex1 == 0) {
                    this.imgIndex1 = 1
                }
            } else if (type == 3) {
                this.imgIndex2 = this.imgIndex2 == 0 ? this.imgList2.length - 1 : this.imgIndex2 - 1;
            } else if (type == 4) {
                this.imgIndex2 = this.imgIndex2 == this.imgList2.length - 1 ? 0 : this.imgIndex2 + 1;
            }
        },
        getGood(language, ifGun) {
            let data = {
                id: this.GoodId,
                language
            }
            // 优先使用点击传递的bottomGoodId（新产品ID）
            if (this.bottomGoodId != null) {
                data.id = this.bottomGoodId;
            }
            GoodDetail(data).then((res) => {
                this.GoodDetail = res.data;
                // 1. 重置图片列表和索引（避免旧数据残留）
                this.imgList1 = [];
                this.imgList2 = [];
                this.imgList3 = [];
                this.imgList4 = [];
                this.projectData1Fen = [];
                this.projectData1FenIndex = 0;

                this.imgIndex1 = 1;
                this.imgIndex2 = 0;
                this.imgIndex3 = 0;
                this.imgIndex4 = 0;

                // 关联产品
                this.loadRelatedProductImages(this.GoodDetail.related_products || [], language);

                // 2. 分类加载图片
                for (let i = 0; i < this.GoodDetail.images.length; i++) {
                    if (this.GoodDetail.images[i].image_type == 'interior') {
                        this.imgList1 = this.GoodDetail.images[i].image_url.split(',');
                    }
                    if (this.GoodDetail.images[i].image_type == 'footer') {
                        this.imgList2 = this.GoodDetail.images[i].image_url.split(',');
                    }
                    if (this.GoodDetail.images[i].image_type == 'recommend') {
                        this.imgList4 = this.GoodDetail.images[i].image_url.split(',');
                    }
                    if (this.GoodDetail.images[i].image_type == 'general') {
                        const imgArr = []
                        const altArr = this.GoodDetail.images[i].alt.split(',')

                        for (let j = 0; j < this.GoodDetail.images[i].image_url.split(',').length; j++) {
                            imgArr.push({
                                src: this.GoodDetail.images[i].image_url.split(',')[j],
                                alt: altArr[j]
                            })
                        }
                        console.log('imgArr' + imgArr)
                        this.projectData1 = imgArr;
                        const result = [];
                        for (let i = 0; i < this.projectData1.length; i += 3) {
                            // 截取从i开始，长度为size的子数组（不足3个则取剩余）
                            const chunk = this.projectData1.slice(i, i + 3);
                            result.push(chunk);
                        }
                        this.projectData1Fen = result;
                        console.log('fen' + this.projectData1Fen)
                    }
                }
                if (!ifGun) {

                } else {
                    // 3. 核心：新数据加载完成后，页面平滑滚动到顶部
                    window.scrollTo({
                        top: 0, // 滚动到页面顶部
                        behavior: 'smooth' // 平滑滚动（去掉则为瞬间跳转）
                    });
                }

            })
        },
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style>
/* 添加样式 */
.Project {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
}

.Project_mobile {
    height: 88%;
}

.Project_box {
    width: 71%;
    margin: 60px auto;
}

.Project_box_mobile {
    margin: 20px auto;
    width: 94%;
}

.Project_top {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #021131;
    margin-bottom: 10px;
}

.Project_title {
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 28px;
    color: #021131;
    line-height: 39px;
}

.Project_img {
    margin: 20px auto;
    width: 100%;
    height: 779px;
    border-radius: 0px 0px 0px 0px;
}

.Project_img_mobile {
    height: 300px;
}

.Project_name {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 24px;
    color: #021131;
    margin-bottom: 60px;
    word-wrap: break-word;
    /* 优先保持单词完整，超宽时拆分 */
    overflow-wrap: break-word;
    /* 兼容部分浏览器（与word-wrap效果一致） */
}

.Project_name_mobile {
    margin-bottom: 0px;
}

.Project_name_right {
    display: flex;
    align-items: center;
}

.pnr_sp {
    justify-content: center;
    margin: 40px auto 60px;
}

.Project_next_img {
    width: 50px;
    height: 50px;
}

.pni_sp {
    margin-right: 20px;
}

.Project_content {
    overflow: auto;
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #021131;
    line-height: 25px;
    text-align: left;
    margin-bottom: 60px;
    word-wrap: break-word;
    /* 优先保持单词完整，超宽时拆分 */
    overflow-wrap: break-word;
    /* 兼容部分浏览器（与word-wrap效果一致） */
}

.Project_content_mobile {
    margin-bottom: 0px;
}

.Project_text {
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 18px;
    color: #021131;
    text-align: left;
    line-height: 25px;
}

.pro_title {
    position: relative;
    text-align: center;
    font-family: Arial, sans-serif;
    font-weight: 600;
    font-size: 52px;
    color: #021131;
    margin-bottom: 40px;
}

.pro_title_mobile {
    font-size: 30px;
}

.pos_next_img {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: 0;
    width: 50px;
    height: 50px;
}

.pro_boxs {
    width: 100%;
    margin: 0px auto 40px;
    display: flex;
    align-items: center;
}

.pbb_sp {
    overflow-x: auto;
    height: 380px;
}

.related_boxs {
    height: auto;
    overflow: visible;
    flex-wrap: wrap;
    align-items: flex-start;
    margin-bottom: 60px;
}

.related_box {
    height: auto;
    cursor: pointer;
    margin-bottom: 30px;
}

.related_placeholder {
    width: 100%;
    height: 283px;
    background: #f0f3f9;
    margin-bottom: 20px;
}

.related_name {
    font-family: Arial, sans-serif;
    font-weight: 500;
    font-size: 20px;
    color: #021131;
    margin-bottom: 6px;
}

.related_cat {
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 16px;
    color: #6488C6;
}

.pro_box {
    flex-shrink: 0;
    margin-right: 20px;
    width: 423px;
    height: 283px;
    border-radius: 0px 0px 0px 0px;
    font-family: Arial, sans-serif;
    font-weight: 400;
    font-size: 20px;
    color: #021131;
}

.prob_img {
    width: 100%;
    height: 283px;
    border-radius: 0px 0px 0px 0px;
    margin-bottom: 20px;
}

.spsp {
    display: flex;
    justify-content: end;
}

.pro_button {
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 216px;
    height: 48px;
    border-radius: 0px 0px 0px 0px;
    border: 1px solid #6488C6;
    text-align: center;
    font-family: Arial, sans-serif;
    color: #6488C6;
    line-height: 48px;
    font-size: 20px;
}

.img_spspsp {
    width: 8px;
    height: 14px;
    margin-left: 10px;
}
</style>